import { graphql } from '@/client/services/api/graphql/gql';

export const archiveExpertMutation = graphql(`
  mutation ArchiveExpert($expertId: String!) {
    archiveExpert(expertId: $expertId)
  }
`);
